/* Baby Joe Joe — Cookie consent banner restyle.
   Shopify's Customer Privacy banner is injected at runtime, sometimes
   with inline styles that beat stylesheet rules. We watch for it,
   restructure the DOM (Accept+Decline in their own centered row,
   Manage preferences on its own row beneath them), and apply inline
   styles in brand marigold. */

(function () {
  'use strict';

  var BRAND_ORANGE = '#F28600';
  var BRAND_ORANGE_HOVER = '#D97600';
  var COCOA = '#552811';
  var WHITE = '#ffffff';

  function setStyles(el, styles) {
    if (!el) return;
    for (var k in styles) {
      if (Object.prototype.hasOwnProperty.call(styles, k)) {
        el.style.setProperty(
          k.replace(/[A-Z]/g, function (m) { return '-' + m.toLowerCase(); }),
          styles[k],
          'important'
        );
      }
    }
  }

  function findIn(root, selectors) {
    for (var i = 0; i < selectors.length; i++) {
      var el = root.querySelector(selectors[i]);
      if (el) return el;
    }
    return null;
  }

  function styleBanner(banner) {
    if (!banner || banner.dataset.bjjStyled === '1') return;

    // Title — marigold + cookie emoji
    var title = findIn(banner, [
      '.shopify-pc__banner__title',
      '.shopify-pc__banner__body h1',
      '.shopify-pc__banner__body h2',
      '.shopify-pc__banner__body h3',
      '.shopify-pc__banner__body strong'
    ]);
    if (title) {
      setStyles(title, {
        color: BRAND_ORANGE,
        fontWeight: '600',
        letterSpacing: '0.04em'
      });
      // Strip any leading 🍪 left over from prior JS versions — the
      // emoji is now placed on the right side via CSS ::after.
      if (title.textContent) {
        title.textContent = title.textContent.replace(/^[\s🍪]+/u, '').trim();
      }
    }

    // Banner body text — cocoa dark brown (excluding the title which
    // is already marigold). Includes paragraphs, spans, links.
    var bodyTextEls = banner.querySelectorAll(
      '.shopify-pc__banner__body p, .shopify-pc__banner__body span, .shopify-pc__banner__body a, .shopify-pc__banner__copy p, .shopify-pc__banner__copy span, .shopify-pc__banner__copy a'
    );
    for (var bt = 0; bt < bodyTextEls.length; bt++) {
      setStyles(bodyTextEls[bt], { color: COCOA });
    }

    var accept = findIn(banner, [
      '.shopify-pc__banner__btn-accept',
      'button[class*="accept"]',
      'button[data-pc-accept]'
    ]);
    var decline = findIn(banner, [
      '.shopify-pc__banner__btn-decline',
      'button[class*="decline"]',
      'button[data-pc-decline]'
    ]);
    var managePrefs = findIn(banner, [
      '.shopify-pc__banner__btn-manage-prefs',
      '.shopify-pc__banner__btn--link',
      'a[class*="manage"]',
      'button[class*="manage"]',
      'a[class*="prefs"]',
      'button[class*="prefs"]'
    ]);

    var pillStyle = {
      backgroundColor: BRAND_ORANGE,
      background: BRAND_ORANGE,
      color: WHITE,
      border: '1px solid ' + BRAND_ORANGE,
      borderRadius: '999px',
      padding: '1.2rem 2.8rem',
      minWidth: '14rem',
      cursor: 'pointer',
      fontWeight: '500',
      letterSpacing: '0.04em',
      textAlign: 'center',
      transition: 'background-color 0.16s ease, border-color 0.16s ease'
    };

    [accept, decline].forEach(function (btn) {
      if (!btn) return;
      setStyles(btn, pillStyle);
      btn.addEventListener('mouseenter', function () {
        setStyles(btn, { backgroundColor: BRAND_ORANGE_HOVER, background: BRAND_ORANGE_HOVER, borderColor: BRAND_ORANGE_HOVER });
      });
      btn.addEventListener('mouseleave', function () {
        setStyles(btn, { backgroundColor: BRAND_ORANGE, background: BRAND_ORANGE, borderColor: BRAND_ORANGE });
      });
    });

    // Restructure: wrap Accept + Decline in their own centered row,
    // then place Manage preferences on its own row below.
    if (accept && decline) {
      var actionsParent = accept.parentElement;
      if (actionsParent && actionsParent === decline.parentElement) {
        setStyles(actionsParent, {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '1rem',
          width: '100%',
          marginTop: '0.4rem'
        });

        var row = actionsParent.querySelector('.bjj-cookie-row');
        if (!row) {
          row = document.createElement('div');
          row.className = 'bjj-cookie-row';
          setStyles(row, {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '1.2rem',
            flexWrap: 'wrap',
            width: '100%'
          });
          actionsParent.insertBefore(row, accept);
        }
        row.appendChild(accept);
        row.appendChild(decline);

        if (managePrefs) {
          setStyles(managePrefs, {
            display: 'block',
            width: 'auto',
            margin: '0.4rem auto 0',
            padding: '0.6rem 1.2rem',
            background: 'transparent',
            backgroundColor: 'transparent',
            border: '0',
            color: 'inherit',
            textAlign: 'center',
            textDecoration: 'underline',
            textUnderlineOffset: '0.22em',
            cursor: 'pointer',
            fontWeight: '400'
          });
          actionsParent.appendChild(managePrefs);
        }
      }
    }

    // Center the dialog body + title block
    var dialog = banner.querySelector('.shopify-pc__banner__dialog');
    if (dialog) {
      setStyles(dialog, {
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '1.4rem',
        maxWidth: '84rem',
        marginLeft: 'auto',
        marginRight: 'auto'
      });
    }

    var bodyEl = banner.querySelector('.shopify-pc__banner__body, .shopify-pc__banner__copy');
    if (bodyEl) {
      setStyles(bodyEl, {
        textAlign: 'center',
        marginLeft: 'auto',
        marginRight: 'auto',
        maxWidth: '78rem'
      });
    }

    banner.dataset.bjjStyled = '1';
  }

  var pillStyleShared = {
    backgroundColor: BRAND_ORANGE,
    background: BRAND_ORANGE,
    color: WHITE,
    border: '1px solid ' + BRAND_ORANGE,
    borderRadius: '999px',
    padding: '1rem 2rem',
    minWidth: '12rem',
    cursor: 'pointer',
    fontWeight: '500',
    letterSpacing: '0.04em',
    textAlign: 'center',
    transition: 'background-color 0.16s ease, border-color 0.16s ease'
  };

  // Apply pill style to button + force WHITE on button + every descendant.
  // Then attach a MutationObserver that re-applies whenever Shopify mutates
  // the button or its children — Shopify's privacy widget sometimes
  // re-renders, and we don't want our styles wiped.
  function lockButtonStyle(btn) {
    function reapply() {
      setStyles(btn, pillStyleShared);
      setStyles(btn, { color: WHITE });
      var kids = btn.querySelectorAll('*');
      for (var k = 0; k < kids.length; k++) {
        setStyles(kids[k], { color: WHITE, backgroundColor: 'transparent', background: 'transparent' });
      }
    }
    reapply();
    if (!btn.dataset.bjjBtnLocked) {
      btn.dataset.bjjBtnLocked = '1';
      var obs = new MutationObserver(reapply);
      obs.observe(btn, {
        attributes: true,
        attributeFilter: ['style', 'class'],
        childList: true,
        subtree: true,
        characterData: true
      });
      // Also reapply for first 3 seconds at 200ms intervals as a safety net
      // for race conditions with Shopify's rendering pipeline.
      var ticks = 0;
      var iv = setInterval(function () {
        reapply();
        if (++ticks >= 15) clearInterval(iv);
      }, 200);
    }
  }

  function attachHover(btn) {
    btn.addEventListener('mouseenter', function () {
      setStyles(btn, { backgroundColor: BRAND_ORANGE_HOVER, background: BRAND_ORANGE_HOVER, borderColor: BRAND_ORANGE_HOVER });
    });
    btn.addEventListener('mouseleave', function () {
      setStyles(btn, { backgroundColor: BRAND_ORANGE, background: BRAND_ORANGE, borderColor: BRAND_ORANGE });
    });
  }

  // Idempotent — re-runs on every mutation so that re-renders (e.g. checkbox
  // toggling) don't blow our styling away.
  function stylePrefs(prefs) {
    if (!prefs) return;

    // Cocoa text color on the panel itself — children inherit unless overridden.
    setStyles(prefs, { color: COCOA });

    // Force cocoa on all common text elements (some Shopify nodes set their
    // own color and don't inherit). Skip text inside buttons — handled below.
    var textEls = prefs.querySelectorAll(
      'h1, h2, h3, h4, h5, h6, p, label, span, strong, em, li, dt, dd, a, small, div'
    );
    for (var t = 0; t < textEls.length; t++) {
      var el = textEls[t];
      if (el.closest('button')) continue;
      setStyles(el, { color: COCOA });
    }

    // Underline + cocoa for in-text links (privacy policy etc.)
    var links = prefs.querySelectorAll('a');
    for (var l = 0; l < links.length; l++) {
      setStyles(links[l], { color: COCOA, textDecoration: 'underline' });
    }

    // Pill-style the action buttons (Accept all / Decline all / Save my choices).
    // The close (×) button stays minimal but gets cocoa color for consistency.
    var allButtons = prefs.querySelectorAll('button');
    for (var i = 0; i < allButtons.length; i++) {
      var btn = allButtons[i];
      var cls = btn.className || '';
      var isClose = /close/i.test(cls) || btn.getAttribute('aria-label') && /close/i.test(btn.getAttribute('aria-label'));
      if (isClose) {
        setStyles(btn, {
          color: COCOA,
          borderColor: COCOA,
          background: 'transparent',
          backgroundColor: 'transparent'
        });
        continue;
      }
      // Any non-close button inside the prefs panel becomes a marigold pill.
      lockButtonStyle(btn);
      if (!btn.dataset.bjjHover) {
        attachHover(btn);
        btn.dataset.bjjHover = '1';
      }
    }

    // Checkbox styling — covers native (accent-color) AND custom-styled
    // checkboxes (Shopify often hides the native input and uses a sibling
    // span with appearance:none and a dark background).
    var checkboxes = prefs.querySelectorAll('input[type="checkbox"]');
    for (var j = 0; j < checkboxes.length; j++) {
      var cb = checkboxes[j];
      setStyles(cb, { accentColor: BRAND_ORANGE });
      applyCheckboxFill(cb);
      if (!cb.dataset.bjjCbHook) {
        cb.addEventListener('change', function (e) { applyCheckboxFill(e.target); });
        cb.dataset.bjjCbHook = '1';
      }
    }
  }

  // Detect if a CSS color string represents a dark color (avg RGB < 100).
  function isDarkColor(color) {
    if (!color || color === 'transparent' || color === 'rgba(0, 0, 0, 0)') return false;
    var m = color.match(/\d+(?:\.\d+)?/g);
    if (!m || m.length < 3) return false;
    var avg = (parseInt(m[0], 10) + parseInt(m[1], 10) + parseInt(m[2], 10)) / 3;
    var alpha = m.length >= 4 ? parseFloat(m[3]) : 1;
    return avg < 110 && alpha > 0.5;
  }

  // Apply marigold fill to the visible checkbox square.
  // Shopify hides the native input and renders a separate visual element
  // (sibling/child of the label) with a dark background. We find any small
  // dark-backgrounded square near the input and override it.
  function applyCheckboxFill(cb) {
    if (!cb) return;
    var checked = cb.checked;

    function paint(el) {
      if (checked) {
        setStyles(el, {
          backgroundColor: BRAND_ORANGE,
          background: BRAND_ORANGE,
          backgroundImage: 'none',
          borderColor: BRAND_ORANGE
        });
      } else {
        el.style.removeProperty('background-color');
        el.style.removeProperty('background');
        el.style.removeProperty('background-image');
        el.style.removeProperty('border-color');
      }
    }

    // Style the input itself (covers `appearance: none` inputs).
    paint(cb);

    // Walk up to 4 levels of ancestors and collect candidates.
    var seen = new Set();
    var candidates = [];
    var ancestor = cb.parentElement;
    for (var d = 0; d < 4 && ancestor; d++) {
      var pool = ancestor.querySelectorAll('span, div, i, b, em, label');
      for (var p = 0; p < pool.length; p++) {
        if (pool[p] === cb) continue;
        if (!seen.has(pool[p])) {
          seen.add(pool[p]);
          candidates.push(pool[p]);
        }
      }
      ancestor = ancestor.parentElement;
    }

    // Filter: small square-ish elements with a dark background OR a
    // border (suggests a checkbox visual) and no significant text content.
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      // Skip elements with text content — they're labels, not visuals.
      if (el.children.length === 0 && el.textContent && el.textContent.trim().length > 1) continue;

      var rect = el.getBoundingClientRect();
      var isSquareish =
        rect.width >= 10 && rect.width <= 48 &&
        rect.height >= 10 && rect.height <= 48 &&
        Math.abs(rect.width - rect.height) <= 8;
      if (!isSquareish) continue;

      var style = window.getComputedStyle(el);
      var hasDarkBg = isDarkColor(style.backgroundColor);
      var hasBorder = parseFloat(style.borderTopWidth) > 0 ||
                      parseFloat(style.borderLeftWidth) > 0;

      if (hasDarkBg || hasBorder) {
        paint(el);
        // Lock it: re-apply on style/class mutations so Shopify can't undo us.
        if (!el.dataset.bjjLocked) {
          el.dataset.bjjLocked = '1';
          var lock = new MutationObserver(function () {
            if (cb.checked) paint(el);
          });
          lock.observe(el, { attributes: true, attributeFilter: ['style', 'class'] });
        }
      }
    }
  }

  function tryStyleAll() {
    var banners = document.querySelectorAll('#shopify-pc__banner, .shopify-pc__banner');
    for (var i = 0; i < banners.length; i++) styleBanner(banners[i]);

    // Broader prefs-panel detection: covers id/class variants and modal containers.
    var prefsPanels = document.querySelectorAll(
      '#shopify-pc__prefs, .shopify-pc__prefs, [id*="shopify-pc__prefs"], [class*="shopify-pc__prefs"]'
    );
    for (var k = 0; k < prefsPanels.length; k++) stylePrefs(prefsPanels[k]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryStyleAll);
  } else {
    tryStyleAll();
  }

  var obs = new MutationObserver(function () { tryStyleAll(); });
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();
